import { useShowLeaderSettings } from '../leaderSettings';
import { useCurrentSessionUser } from '../session';

type UseCanCurrentUserAccessAdminSettings = () => boolean;
export const useCanCurrentUserAccessAdminSettings: UseCanCurrentUserAccessAdminSettings = () => {
  const { canAssignUserAdminRoles, isNetworkAdmin } = useCurrentSessionUser();
  const showLeaderSettings = useShowLeaderSettings();

  return canAssignUserAdminRoles || showLeaderSettings || isNetworkAdmin;
};
